import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IUpdateFixedPaymentsPayload, IUpdateFixedPaymentsResponse } from '../types';
import {
  AFFILIATE_TRACKERS_UPDATE_FIXED_PAYMENTS__API_URL,
  AFFILIATE_TRACKERS_UPDATE_FIXED_PAYMENTS_MUTATION,
  AFFILIATES_APPROVED_FIXED_PAYMENTS_PERMISSIONS,
} from '../constants';

export default function useUpdateFixedTrackerPaymentsMutation(): IContextMutationResult<IUpdateFixedPaymentsResponse, Error, IUpdateFixedPaymentsPayload> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<IUpdateFixedPaymentsResponse, Error, IUpdateFixedPaymentsPayload>({
    mutationKey: [AFFILIATE_TRACKERS_UPDATE_FIXED_PAYMENTS_MUTATION],
    mutationFn: ({ affiliateId, trackerId, ...payload }) => fetchPut<IUpdateFixedPaymentsResponse>(
      AFFILIATE_TRACKERS_UPDATE_FIXED_PAYMENTS__API_URL,
      payload,
      {
        permission: AFFILIATES_APPROVED_FIXED_PAYMENTS_PERMISSIONS.HISTORY_CHANGES_EDIT,
        urlParams: {
          affiliateId,
          trackerId,
        },
      },
    ),
    onSuccess() {
      displayPresetToast('edited');
    },
  });
}
